import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, CheckCircle } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function Settings() {
  const [user, setUser] = useState(null);
  const [saEmail, setSaEmail] = useState("");
  const [saError, setSaError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const me = await api.get("/auth/me");
        setUser(me.data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Settings /auth/me failed", e);
      }
      try {
        const sa = await api.get("/sheets/service-account");
        setSaEmail(sa.data.email);
      } catch (e) {
        setSaError(e.response?.data?.detail || "Google Sheets is not configured on this deployment.");
      }
    })();
  }, []);

  const copyEmail = () => {
    navigator.clipboard.writeText(saEmail);
    toast.success("Copied");
  };

  return (
    <div className="p-8 lg:p-12 max-w-[900px]">
      <header className="mb-8">
        <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-2">Settings</div>
        <h1 className="font-display text-5xl font-black tracking-tight" data-testid="settings-title">Your account</h1>
      </header>

      <section className="bg-white border border-stone-200 p-8 mb-6">
        <div className="text-xs uppercase tracking-widest text-neutral-500 mb-3">Profile</div>
        {user && (
          <div className="flex items-center gap-4">
            {user.picture ? (
              <img src={user.picture} alt="" className="w-16 h-16 rounded-full border border-stone-200" />
            ) : (
              <div className="w-16 h-16 rounded-full bg-neutral-200 grid place-items-center text-2xl font-bold">
                {user.name?.[0]?.toUpperCase()}
              </div>
            )}
            <div>
              <div className="font-display text-2xl font-bold">{user.name}</div>
              <div className="text-neutral-500 font-mono-tech text-sm">{user.email}</div>
            </div>
          </div>
        )}
      </section>

      <section className="bg-white border border-stone-200 p-8">
        <div className="text-xs uppercase tracking-widest text-neutral-500 mb-2">Google Sheets access</div>
        <div className="font-display text-xl font-bold flex items-center gap-2 mb-3">
          {saEmail ? (
            <><CheckCircle weight="fill" size={18} className="text-emerald-600" /> Service account active</>
          ) : (
            <>Not configured</>
          )}
        </div>

        {saEmail ? (
          <>
            <p className="text-neutral-600 text-sm mb-4">
              Share any Google Sheet with the following email (as <b>Viewer</b>) to let ReviewFlow read new rows from it.
            </p>
            <div className="flex items-center gap-2 bg-stone-50 border border-stone-300 px-3 py-2.5 font-mono-tech text-sm max-w-lg">
              <span className="truncate flex-1" data-testid="settings-sa-email">{saEmail}</span>
              <button
                data-testid="settings-copy-sa"
                onClick={copyEmail}
                className="text-xs font-semibold text-[#F58021] hover:underline inline-flex items-center gap-1"
              >
                <Copy size={13} /> Copy
              </button>
            </div>
          </>
        ) : (
          <p className="text-red-700 text-sm">{saError}</p>
        )}
      </section>
    </div>
  );
}
